import { connect } from "react-redux";

import LoginPage from "./LoginPage";

import { reducer, mapStateToProps, mapDispatchToProps } from "./LoginPage.state";

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);

export { reducer, mapStateToProps, mapDispatchToProps };
